import type { ComponentType, ReactNode } from 'react';

import type { NextSearchParams } from '../../../../../schema/frameworks/entry.js';
import { validate, type Validator } from '../../../../../schema/input/entry.js';

type WithQueryParametersProps = Validator['query'] & {
  searchParams: NextSearchParams;
};

type Parameters = keyof Validator['query'];

/**
 * Sanitize and validate query parameters. If invalid, an error will be thrown.
 *
 * @param parameters parameters to validate
 * @returns typed query parameters object
 */
export function withQueryParameters(...parameters: Parameters[]) {
  return <TProps extends WithQueryParametersProps>(WrappedComponent: ComponentType<TProps>) => {
    return function WithQueryParameters({ searchParams, ...props }: WithQueryParametersProps): ReactNode {
      const validatedSearchParams = validate.query(...parameters).parse(searchParams);

      return (
        // Return and omit searchParams from props
        <WrappedComponent {...(props as TProps)} {...validatedSearchParams} />
      );
    };
  };
}
